import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-code-type',
  template: `
    <div class="mb-3" style="height: 600px">
      <h3 *ngIf="to.label">{{ to.label }}</h3>
      <p *ngIf="to.description">{{ to.description }}</p>

      <div class="alert alert-danger" role="alert" *ngIf="showError && formControl.errors">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>

      <ngx-monaco-editor
        [formControl]="formControl"
        [options]="editorOptions"
        [formlyAttributes]="field"></ngx-monaco-editor>
    </div>
  `
})
export class CodeTypeComponent extends FieldType<FieldTypeConfig> {
  editorOptions = {
    theme: 'light'
  };
}
